import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker';
import logout from './../../Global/logout';

export default async function DeleteNaplatniUredaj(   
   clientUuid = "",
   deviceUuid = ""
) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    let query = "/" + deviceUuid + "?clientUuid=" + clientUuid
    return await resolve(
        axios( 'provider/client/device' + query, {
            method: 'delete',
            headers: { 'Authorization' : unHashedJwt.data}           
        }).then(res => res.data)
        .catch(error => error.response.data),
        "Admin"
        );
}